module.exports = __webpack_public_path__ + "img/verification_error.832b3538.jpg";